import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { ErrorBoundary } from './components/ErrorBoundary'
import { PageLoadingFallback } from './components/LoadingFallback'
import { ThemeProvider } from './contexts/ThemeContext'
import { ToastProvider } from './contexts/ToastContext'
import { SessionManager } from './components/SessionManager'
import { SystemAnnouncementModal } from './components/common/SystemAnnouncementModal'

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <SessionManager />
        <SystemAnnouncementModal />
        <ErrorBoundary>
          <Suspense fallback={<PageLoadingFallback />}>
            <RouterProvider router={router} />
          </Suspense>
        </ErrorBoundary>
      </ToastProvider>
    </ThemeProvider>
  )
}

export default App
